import(/* webpackMode: "eager" */ "/vercel/path0/app/services/smart-services.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/newlp/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/services/SmartServicesPage.tsx");
